import { createFileRoute, Outlet } from "@tanstack/react-router";

// Sổ khách bí mật (M7). Deliberately absent from nav-items/routeTitles —
// reachable only by typing the URL. The view blind-guards on
// spotcheck.manage, and the BE 403s independently.
export const Route = createFileRoute("/_app/spot-checks")({
  component: () => <Outlet />,
});
